import { type SearchStore } from "@search/store/types";
import { createContext } from "react";
import { StoreApi } from "zustand";

export const SearchContext = createContext<StoreApi<SearchStore> | null>(null);
